// Global registration of all Vue components in folder components/form/base
import { defineAsyncComponent } from 'vue'

import ECheckbox from '@/components/form/base/ECheckbox.vue'
import EColorPicker from '@/components/form/base/EColorPicker.vue'
import EColorField from '@/components/form/base/EColorField.vue'
import EDatePicker from '@/components/form/base/EDatePicker.vue'
import EForm from '@/components/form/base/EForm.vue'
import ENumberField from '@/components/form/base/ENumberField.vue'
import EPasswordField from '@/components/form/base/EPasswordField.vue'
import EParseField from '@/components/form/base/EParseField.vue'
import ESelect from '@/components/form/base/ESelect.vue'
import ESwitch from '@/components/form/base/ESwitch.vue'
import ETextField from '@/components/form/base/ETextField.vue'
import ETimePicker from '@/components/form/base/ETimePicker.vue'

class FormBaseComponentsPlugin {
  install(Vue) {
    Vue.component('ECheckbox', ECheckbox)
    Vue.component('EColorField', EColorField)
    Vue.component('EColorPicker', EColorPicker)
    Vue.component('EDatePicker', EDatePicker)
    Vue.component('EForm', EForm)
    Vue.component('ENumberField', ENumberField)
    Vue.component('EPasswordField', EPasswordField)
    Vue.component('EParseField', EParseField)
    Vue.component(
      'ERichtext',
      defineAsyncComponent(() => import('@/components/form/base/ERichtext.vue'))
    )
    Vue.component('ESelect', ESelect)
    Vue.component('ESwitch', ESwitch)
    Vue.component(
      'ETextarea',
      defineAsyncComponent(() => import('@/components/form/base/ETextarea.vue'))
    )
    Vue.component('ETextField', ETextField)
    Vue.component('ETimePicker', ETimePicker)
  }
}

export default new FormBaseComponentsPlugin()
